import {
  DailyInventoryControlNotification,
  dailyInventoryControlNotification,
} from "api/generated";
import { useClient } from "hooks/useClient";
import { useEffect } from "react";
import { notification, Table, Button } from "antd";

const useStockNotifications = (hasEditPermission: boolean) => {
  const { client } = useClient();

  function openStockNotification(
    notifications: DailyInventoryControlNotification[]
  ) {
    const key = `open${Date.now()}`;
    const columns = [
      {
        title: "Producto",
        dataIndex: "inventoryControlNotificationProductName",
      },
      {
        title: "Diferencia",
        dataIndex: "inventoryControlPercentageDifference",
      },
    ];
    const dataTable = notifications.map((item) => ({
      key: item.inventoryControlNotificationProductName,
      inventoryControlNotificationProductName:
        item.inventoryControlNotificationProductName,
      inventoryControlPercentageDifference:
        item.inventoryControlPercentageDifference,
    }));

    const btn = (
      <>
        <Button
          key="later"
          style={{ color: "#1D98CD", marginRight: "14px" }}
          size="small"
          onClick={() => notification.destroy(key)}
        >
          Registrar después
        </Button>
        <Button
          key="now"
          style={{
            marginLeft: "14px",
            background: "#1D98CD",
            color: "#FFFFFF",
          }}
          type="primary"
          size="small"
          onClick={() => {
            notification.destroy(key);
            window.location.replace("/stockControl");
          }}
        >
          Registrar ahora
        </Button>
      </>
    );

    notification.info({
      message: "Inconsistencias en la información volumétrica",
      description: (
        <div>
          <p style={{ textAlign: "justify" }}>
            {`Se encontraron algunas inconsistencias entre el volumen lógico y el volumen manual del día de ayer ${notifications[0]?.inventoryControlNotificationDay} 
            de ${notifications[0]?.inventoryControlNotificationMonth} de ${notifications[0]?.inventoryControlNotificationYear} en los siguientes productos:`}
          </p>
          <Table
            columns={columns}
            dataSource={dataTable}
            size="small"
            pagination={false}
          />
          <br />
          <p style={{ textAlign: "justify" }}>
            Favor de ir al menú "Control de existencias" para registrar la
            posible causa y las acciones que se tomarán para su correción y
            seguimiento de cada una de las inconsistencias.
          </p>
          <p>Dispones del día de hoy para completar esa información.</p>
        </div>
      ),
      style: {
        width: 522,
        marginLeft: 335 - 522,
      },
      duration: 0,
      btn,
      key,
    });
  }

  useEffect(() => {
    if (!hasEditPermission) return;

    const checkStockInconsistencies = () => {
      dailyInventoryControlNotification({ client })
        .then(({ data }) => {
          if (data?.some((elem) => elem.inventoryControlUserNotified === false))
            openStockNotification(data);
        })
        .catch((error) => {
          console.error("Error checking stock inconsistencies:", error);
        });
    };

    checkStockInconsistencies();

    // Configurar intervalo
    const interval = setInterval(checkStockInconsistencies, 1800000); // 30 minutos
    return () => clearInterval(interval);
  }, [hasEditPermission, client]);
};

export default useStockNotifications;
